import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { initialMultiSelectState, MultiSelectClassificationState } from '../../components/MultiSelectClassification';

export interface FlashcardState {
  classification: MultiSelectClassificationState;
  globalSearch: string;
  type: 'all' | 'myDeck' | 'myFlashcards';
}

export interface FlashcardStatePayload {
  name: keyof FlashcardState;
  value: string;
}

export const flashcardInitialState: FlashcardState = {
  classification: initialMultiSelectState,
  globalSearch: '',
  type: 'all',
};

const { reducer, actions } = createSlice({
  name: 'flashcard',
  initialState: flashcardInitialState,
  reducers: {
    setClassification: (state, action: PayloadAction<MultiSelectClassificationState>): FlashcardState => {
      const newClassification = action.payload;

      return {
        ...state,
        classification: newClassification,
      };
    },
    setField: (state, action: PayloadAction<FlashcardStatePayload>): FlashcardState => {
      const { name, value } = action.payload;

      return {
        ...state,
        [name]: value,
      };
    },
    reset: (): FlashcardState => ({
      ...flashcardInitialState,
    }),
  },
});

const persistentReducer = persistReducer({
  key: 'flashcard',
  storage,
}, reducer);

export { actions };
export default persistentReducer;
